import { createAsyncThunk } from "@reduxjs/toolkit";
import { getMealPlan } from "api/api";

export const setFoodyWeek = createAsyncThunk("SET_FOODY_WEEK", async (id) => {
  const res = await getMealPlan(id);
  return res.data;
});
